module.exports = __webpack_public_path__ + "static/media/familyStories.8c0c3c19.png";